// Vars //
var $body = jQuery('body');

function backToTop() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 100) {
            body.addClass("show-scroll-to-top");
        } else {
            body.removeClass("show-scroll-to-top");
        }
    });
}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Feature Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            centerMode: centerMode,
            mobileFirst: true,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>',
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4.5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3.5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

/**
 * 
 * Feature Category Product Slider
 * 
 */
 function featureProductCategorySliderSetup() {
    jQuery('.feature-product-category-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-category-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        // Calc max slides to show //
        var slide_count = $slider.find('.slide').length;
        var xxl_slidesToShow;
        if (slide_count < 5) {
            xxl_slidesToShow = slide_count;
        } else {
            xxl_slidesToShow = 5;
        }
        var xl_slidesToShow;
        if (slide_count < 4) {
            xl_slidesToShow = slide_count;
        } else {
            xl_slidesToShow = 4;
        }
        
        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            mobileFirst: true,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            centerPadding: '50px',
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>',

            responsive: [
                {
                    breakpoint: 1890,
                    settings: {
                        slidesToShow: xxl_slidesToShow,
                        slidesToScroll: 1,
                        centerPadding: '70px',
                    }
                },{
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: xl_slidesToShow,
                        slidesToScroll: 1,
                        centerPadding: '70px',
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerPadding: '70px'
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
}

/**
 * 
 * Content Block Slider
 * 
 */
function contentBlockSliderSetup() {
    jQuery('.slider-content-block.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-content-block');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Logo Slider Block - sc-logo-slider-block.twig
 * 
 */
function logoSliderBlockSetup() {
    jQuery('.logo-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.logo-slider-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }


        if (jQuery(window).width() > 1600) {
            slidesToShow = 6;
        } else if (jQuery(window).width() > 1400) {
            slidesToShow = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}